import { render, staticRenderFns } from "./NonMedicalInfo.vue?vue&type=template&id=51f07ea3"
import script from "./NonMedicalInfo.vue?vue&type=script&lang=js"
export * from "./NonMedicalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports